import React from 'react';
import './App.css';
import './themes/themes.css';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { metaPixel } from './Hooks/metaPixel';
import usePageTracking from './Hooks/usePageTracking';
import useGlobalTracking from './Hooks/useGlobalTracking';

import Layout from './layouts/Layout';
import Dashboard from './pages/home/Dashboard';
import AboutUs from './pages/about/AboutUs';
import ContactPage from './pages/contact/ContactPage';
import EventDetails from './pages/events/EventDetails';
import HowToBecomeMember from './pages/membership/HowToBecomeMember';
import JoinUs from './pages/membership/JoinUs';
import MembershipApplication from './pages/membership/MembershipApplication';
import Benefits from './pages/benefits/Benefits';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import TermsOfService from './pages/legal/TermsOfService';

function App() {
  const location = useLocation();

  useEffect(() => { metaPixel('PageView'); }, [location]);
  useEffect(() => { ReactGA.initialize('G-VZKVYM6GDY'); }, []);

  usePageTracking();
  useGlobalTracking();

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="about" element={<AboutUs />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="events" element={<EventDetails />} />
        <Route path="membership" element={<HowToBecomeMember />} />
        <Route path="join-us" element={<JoinUs />} />
        <Route path="become-member" element={<JoinUs />} />
        <Route path="membership-application" element={<MembershipApplication />} />
        <Route path="benefits" element={<Benefits />} />
        <Route path="privacy" element={<PrivacyPolicy />} />
        <Route path="terms" element={<TermsOfService />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
